// colors.ts
const colors = {
  white: '#fff',
  black: '#000',

  // Primary colors
  orange: '#fd7e14',
  teal: '#02a8b5',
  blue: '#2c7be5',
  darkBlue: '#27BCFD33',

  // Success, Warning, and Error
  success: '#00d27a',
  warning: '#fd7e14',
  error: '#e63757',

  // Grayscale
  grayLight: '#f9fafd',
  grayLight2: '#ebeef1',
  grayMid: '#9da9bb',
  grayDark: '#748194',
  grayDisabled: '#9da9bb',

  // Green Shades
  greenLight: '#b3f2d7',
  greenLight2: '#f0f7f2',
  green: '#00d27a',
  darkGreen: '#01824c',

  // Red Shades
  red: '#e63757',
  redLight: '#fad7dd',

  // Purple
  purpleLight2: '#f0f1f8',
};

export default colors;
